import { ShimmerDepartmentRender } from "components/app/shrimmer/Shrimmer";

const StaffDepartment = ({ setHovered, hovered, setEditItemCategories, handleClickCategory, selectedProductGroupCode, loadingFetchDataDepartment, alldepartment }: any) => {
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
    >
      {/* Hover Overflow Scroll Container */}
      <div className="relative w-full ">
        <div className="flex space-x-2 w-full">
          {/* Add Category */}

          {/* "All" Category */}
          <div
            onClick={() => {
              setEditItemCategories("");

              if (selectedProductGroupCode === "All") {
                setEditItemCategories("");
              }
              handleClickCategory({
                categoryName: "",
                groupId: "",
              });
            }}
            className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
              selectedProductGroupCode === "" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
            }`}
          >
            <span className="lg:text-sm md:text-sm text-[12px]">All</span>
          </div>
          {/* Product Categories */}
          <div className="space-x-2 flex ">
            {loadingFetchDataDepartment ? (
              <>
                <ShimmerDepartmentRender />
              </>
            ) : (
              <>
                {alldepartment?.map((group: any) => (
                  <div key={group.id} className="flex items-center">
                    {group.department && (
                      <div
                        className={`flex items-center  w-auto whitespace-nowrap lg:h-14 md:h-12 h-10  border rounded-md cursor-pointer font-semibold 
                                   ${
                                     selectedProductGroupCode === (group?.department ? group.department.toString() : "")
                                       ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200"
                                       : "dark:hover:bg-slate-900"
                                   }`}
                        onClick={() => {
                          setEditItemCategories(group.department);
                          handleClickCategory({
                            categoryName: group?.department ?? "", // Ensure it's a string or fallback to ""
                            groupId: group?.product_group_id,
                          });
                        }}
                      >
                        <div className="flex group ">
                          <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden flex items-center justify-center">
                            {group?.department ?? "No department"}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffDepartment;
